module.exports = __webpack_public_path__ + "img/gotop.2068a0ff.png";